import ERP from "../ERP.mjs";
import Schema from "../Schema.mjs";

export default {

    async getFornecedor(fornecedorID = ""){

        let fornecedor;

        try{

            fornecedor = await ERP.getOneById(Schema.FORNECEDOR, fornecedorID);
            if(fornecedor.status != 200){
                throw fornecedor;
            }

            console.log(fornecedor);

        }catch(e){

            console.log(e);
            return fornecedor;

        }

        return fornecedor;

    },

    async alterarFornecedor(fornecedorValores = {}){

        let fornecedor;

        try{

            fornecedor = await ERP.patchOne(Schema.FORNECEDOR, fornecedorValores);
            if(fornecedor.status != 200){
                throw fornecedor;
            }

            console.log(fornecedor);

        }catch(e){

            console.log(e);
            return fornecedor;

        }

        return fornecedor;

    },

}